import Form from 'containers/SignupPages/AuthByContractEpargnEmailCodeInput/Form';
import messages from 'containers/SignupPages/AuthByContractEpargnEmailCodeInput/messages';
import { AUTH_BY_CONTRACT_EPARGN_EMAIL } from 'containers/SignupPages/constants';
import Header from 'containers/SignupPages/Header';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { translate } from 'helpers/intl';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { resendEmail } from 'store/user/actions';
import { getEmailSelector } from 'store/user/selectors';

export type AuthByEmailType = {
  intl: IntlShape;
  email: string;
  onSubmitStep: Function;
  isLoading: boolean;
  setSignupStep: Function;
};

const AuthByEmail = (props: AuthByEmailType) => {
  const dispatch = useDispatch();
  return (
    <GaLoadHOC category={EVENT_CATEGORIES.AUTH_BY_EMAIL}>
      <>
        <Header
          title={translate({ ...messages.title }, props)}
          subTitle={`${translate({ ...messages.subTitle }, props)} ${
            props.email
          }`}
        />
        <Form
          resendMail={
            /* istanbul ignore next */ () => {
              dispatch(resendEmail());
            }
          }
          isLoading={props.isLoading}
          onClickPrevious={() => {
            props.setSignupStep(AUTH_BY_CONTRACT_EPARGN_EMAIL);
          }}
          onSubmitStep={props.onSubmitStep}
        />
      </>
    </GaLoadHOC>
  );
};

const mapStateToProps = createStructuredSelector<any, { email: string }>({
  email: getEmailSelector,
});

export default connect(mapStateToProps)(injectIntl(AuthByEmail));
